/** Explicit free authoring handoff. No preparation or Run is reachable from this action. */
import { createContext, useContext, useState } from 'react'
import type { ShopifyResultPhrases, StudyAuthoringRecord } from '@testfeed/shopify-contracts'
import { nextTestsCopy as copy } from '@testfeed/product-language'
import { ActionButton, type ActionButtonLifecycle } from '../ActionButton'
import { withShopifyAppContext } from '../../resultsNavigation'

type DraftAction = NonNullable<ShopifyResultPhrases['proposalGroups'][number]['proposals'][number]['createDraft']>
export const NextTestDraftContext = createContext<{
  lifecycle: ActionButtonLifecycle<'create-next-test'>
  create: (selection: DraftAction['selection']) => Promise<StudyAuthoringRecord | null>
} | null>(null)

export function NextTestDraftAction({ action }: { action: DraftAction | undefined }) {
  const owner = useContext(NextTestDraftContext)
  const [saved, setSaved] = useState<StudyAuthoringRecord | null>(null)
  if (!action || !owner) return null
  if (saved)
    return (
      <s-button href={withShopifyAppContext(`/study-builder?studyId=${encodeURIComponent(saved.studyId)}`)}>
        {copy.openDraft}
      </s-button>
    )
  return (
    <s-stack direction="block" gap="small">
      <s-paragraph color="subdued">{copy.draftNote}</s-paragraph>
      <ActionButton
        lifecycle={owner.lifecycle}
        action="create-next-test"
        onClick={async () => {
          const result = await owner.create(action.selection)
          if (result) setSaved(result)
        }}
      >
        {action.label}
      </ActionButton>
    </s-stack>
  )
}
